import { PapScoreResult } from '../../components/flows/patientAssistance/PapScoring';

export type PapState = {
  scoreResult: PapScoreResult | undefined;
};

export const INITIAL_PAP_STATE: PapState = {
  scoreResult: undefined,
};
